import lstore from '@/utils/localStorage';
import * as types from './mutation-types';
import {
  THEME_LOCAL_STORAGE_KEY,
  THEME_LIGHT,
  THEME_DARK,
} from './constants';

/**
 * Apply theme to the document root element
 * This ensures elements outside the Vue app root (modals, poppers) also get themed
 */
const applyThemeToDocument = (theme) => {
  if (theme === THEME_DARK) {
    document.documentElement.setAttribute('data-theme', 'dark');
  } else {
    document.documentElement.removeAttribute('data-theme');
  }
};

/**
 * Action: Load theme from localStorage
 */
const loadTheme = ({ commit }) => {
  const savedTheme = lstore.getValue(THEME_LOCAL_STORAGE_KEY) || THEME_LIGHT;
  commit(types.SET_THEME, savedTheme);
  applyThemeToDocument(savedTheme);
};

/**
 * Action: Toggle between light and dark theme
 */
const toggleTheme = ({ state, commit }) => {
  const newTheme = state.currentTheme === THEME_LIGHT ? THEME_DARK : THEME_LIGHT;
  commit(types.SET_THEME, newTheme);
  lstore.setValue(THEME_LOCAL_STORAGE_KEY, newTheme);
  applyThemeToDocument(newTheme);
};

/**
 * Action: Set a specific theme
 */
const setTheme = ({ commit }, theme) => {
  commit(types.SET_THEME, theme);
  lstore.setValue(THEME_LOCAL_STORAGE_KEY, theme);
  applyThemeToDocument(theme);
};

export default {
  loadTheme,
  toggleTheme,
  setTheme,
};
